import { Injectable } from '@angular/core';
import { ChecklistOfflineService } from './checklist-offline.service';
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';

@Injectable({
  providedIn: 'root'
})
//ImageProcessorService
export class ExtractHtmlImgService {

  constructor() { }

  /**
   * Procesa HTML descargando imágenes y reemplazando URLs - Versión autónoma
   * @param htmlString - String HTML que contiene imágenes
   * @returns Promise con el HTML modificado con rutas locales
  */

  async processHtmlImages(htmlString: string): Promise<string> {
    try {
      // Crear un parser DOM
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');

      // Obtener todas las imágenes
      const imgElements = doc.querySelectorAll('img');

      if (imgElements.length === 0) {
        return htmlString;
      }

      console.log(`Procesando ${imgElements.length} imagenes...`);

      const imageArray = Array.from(imgElements); // convierte NodeList a array real

      for (let imgElement of imageArray) {
        const originalSrc = imgElement.getAttribute('src');
        console.log("originalSrc:: ", originalSrc)
        if (originalSrc && originalSrc.trim() !== '') {
          try {
            let fileName = `img_${Date.now()}`;
            console.log(`Imagen de html Y fileName:: ${originalSrc}`, fileName);
            const localPath = await this.downloadHtmlImage(
              { url: originalSrc, media_id: fileName }, "photo"
            );
            const webViewPath = Capacitor.convertFileSrc(localPath);
            imgElement.setAttribute('src', webViewPath);
            console.log(`Imagen de html procesada: ${originalSrc} -> ${webViewPath}`);
          } catch (error) {
            console.error(`Error descargando imagen de html de act ${originalSrc}:`, error);
            imgElement.setAttribute('src', "");
            // Mantener src original si falla la descarga
          }
        }
      }

      // // Procesar cada imagen
      // const downloadPromises = Array.from(imgElements).map(async (imgElement, index) => {
      //   const originalSrc = imgElement.getAttribute('src');
      //   if (originalSrc && originalSrc.trim() !== '') {
      //     try {
      //       let fileName = `img_${index}_${Date.now()}`;
      //       console.log(`Imagen de html:: ${originalSrc}`, fileName);
      //       const localPath = await this.downloadHtmlImage(
      //         { url: originalSrc, media_id: fileName }, "photo"
      //       );
      //       const webViewPath = Capacitor.convertFileSrc(localPath);
      //       imgElement.setAttribute('src', webViewPath);
      //       console.log(`Imagen de html procesada: ${originalSrc} -> ${webViewPath}`);
      //     } catch (error) {
      //       console.error(`Error descargando imagen de html de act ${originalSrc}:`, error);
      //       // Mantener src original si falla la descarga
      //     }
      //   }
      // });

      // // Esperar todas las descargas
      // await Promise.all(downloadPromises);

      // Retornar el HTML modificado
      return doc.body.innerHTML;

    } catch (error) {
      console.error('Error procesando HTML con imágenes:', error);
      return htmlString; // Retornar HTML original en caso de error
    }
  }

  async downloadHtmlImage(media, type): Promise<string> {
    let url_media: string = media.url;
    let localUrl = "";
    try {
      let extension = this.getFileExtensionFromUrl(url_media);
      if (!extension) {
        console.log('No extension found in URL, detecting content type...');
        extension = await this.detectContentType(url_media);
      }
      let docName = `${media.media_id}.${extension}`;
      await Filesystem.mkdir({ path: 'ch-img-description', directory: Directory.Data, recursive: true }).catch(() => {});
      const responseDownload = await Filesystem.downloadFile({
        url: url_media,
        path: 'ch-img-description/' + docName,
        directory: Directory.Data,
      });
      localUrl = responseDownload.path;
      console.log('ch-img-description Descargado en:', responseDownload.path);
      return localUrl;
    } catch (err) {
      console.log('error block downloadHtmlImage ... ', err);
      return localUrl;
    }
  }

  private getFileExtensionFromUrl(url: string): string {
    try {
      // Remover parámetros de query (?param=value)
      const urlWithoutParams = url.split('?')[0];

      // Extraer la extensión
      const parts = urlWithoutParams.split('.');
      if (parts.length > 1) {
        const extension = parts[parts.length - 1].toLowerCase();
        // Validar que sea una extensión de imagen común
        const validExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'mp4', 'webm', 'mpeg', 'mov'];
        if (validExtensions.includes(extension)) {
          return extension;
        }
      }
      return null;
    } catch (error) {
      console.log('Error extracting extension:', error);
      return null;
    }
  }

  private async detectContentType(url: string): Promise<string> {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      const contentType = response.headers.get('content-type');
      if (contentType) {
        const typeMap = {
          'image/jpeg': 'jpg', 'image/jpg': 'jpg', 'image/png': 'png',
          'image/gif': 'gif', 'image/webp': 'webp', 'image/bmp': 'bmp',
          'image/svg+xml': 'svg'
        };
        return typeMap[contentType.toLowerCase()] || 'jpg';
      }
      return 'jpg';
    } catch (error) {
      console.log('Error detecting content type:', error);
      return 'jpg';
    }
  }


}

